import React from 'react';
import Helmet from 'react-helmet';
import LocateProductModel from './LocateProductModel';
import { branch } from 'baobab-react/higher-order';

class AboutMySafeSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			Video1: false,
			Video2: false
		};
	}
	
	handleClickVideo1() {
		if (this.state.Video1 === false) {
			this.setState({
				Video1: true,
				Video2: false
			});
		} else {
			this.setState({
				Video1: false,
				Video2: false
			});
		}
	}

	handleClickVideo2() {
		if (this.state.Video2 === false) {
			this.setState({
				Video2: true,
				Video1: false
			});
		} else {
			this.setState({
				Video2: false,
				Video1: false
			});
		}
	}

	render() {
		return (
			<div>
				<Helmet
					title="About My Safe &#124; SentrySafe"
					meta={[{
						property: 'description',
						content: 'Learn more about your SentrySafe safe by watching the quick start and full instructional videos. You can even download the owner\'s manual.'
					}]}
				/>
				<LocateProductModel product={ this.props.product } />
			</div>
		);
	}
}

export default branch({
	product: ['product']
}, AboutMySafeSearch);


// WEBPACK FOOTER //
// ./src/pages/aboutMySafe/Search.js